import { render } from "./ClientAiSideBar.vue?vue&type=template&id=a71cb6a6&scoped=true"
import script from "./ClientAiSideBar.vue?vue&type=script&lang=js"
export * from "./ClientAiSideBar.vue?vue&type=script&lang=js"

import "./ClientAiSideBar.vue?vue&type=style&index=0&id=a71cb6a6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a71cb6a6"]])

export default __exports__